import styled from 'styled-components';
import { Row } from 'antd';

interface LoadingRowProps {
  $height: number;
}

// eslint-disable-next-line import/prefer-default-export
export const LoadingRow = styled(Row)<LoadingRowProps>`
  width: 100%;
  height: ${(props) => `${props.$height}px`};
  align-items: center;
`;
